import React from 'react';
import PropTypes from 'prop-types';

import { formatPhone } from 'utils/formatString';

import NotificationPointPreview from '../NotificationPointPreview';
import NotificationPointEditPopup from '../NotificationPointEditPopup';
import ConfirmationCodePopup from '../ConfirmationCodePopup';

import { NOTIFICATION_POINTS_TYPES } from '../../constants';

const getPointValue = (value, type) => (
  type === NOTIFICATION_POINTS_TYPES.SMS
    ? formatPhone(value)
    : value
);

const NotificationPoint = ({
  type,
  isConfirmed,
  isEnabled,
  isEditing,
  isCodeInvalid,
  togglePoint,
  toggleEditingState,
  saveNotificationPoint,
  confirmNotificationPointCode,
  resetPointCodeValidation,
  resendCode,
  isRecoveryPassword,
  value = '',
  isSaving,
  isToggling,
  isChecking,
  isCodeSending,
  toggleConfirmationCodePopup,
  isConfirmationOpened,
  isEditDisabled,
}) => {
  const pointValue = getPointValue(value, type);

  return (
    <NotificationPointPreview
      pointValue={pointValue}
      type={type}
      isConfirmed={isConfirmed}
      isEnabled={isEnabled}
      isToggling={isToggling}
      isRecoveryPassword={isRecoveryPassword}
      isEditDisabled={isEditDisabled}
      startEditing={() => toggleEditingState({
        type,
        isEditing: true,
      })}
      togglePoint={() => togglePoint({
        type,
        value: !isEnabled,
      })}
      showConfirmationPopup={() => toggleConfirmationCodePopup({
        type,
        isConfirmationOpened: true,
      })}
    >
      <NotificationPointEditPopup
        value={value}
        type={type}
        isRecoveryPassword={isRecoveryPassword}
        isSaving={isSaving}
        savePointValue={(newValue) => saveNotificationPoint({
          type,
          value: newValue || '',
        })}
        cancelPointValue={() => toggleEditingState({
          type,
          isEditing: false,
        })}
        isEditing={isEditing}
      />
      <ConfirmationCodePopup
        isOpened={isConfirmationOpened}
        pointValue={pointValue}
        type={type}
        isCodeInvalid={isCodeInvalid}
        isChecking={isChecking}
        isCodeSending={isCodeSending}
        confirmCode={(confirmationCode) => confirmNotificationPointCode({
          type,
          confirmationCode,
        })}
        resetPointCodeValidation={() => resetPointCodeValidation(type)}
        resendCode={() => resendCode(type)}
        cancelConfirmation={() => toggleConfirmationCodePopup({
          type,
          isConfirmationOpened: false,
        })}
      />
    </NotificationPointPreview>
  );
};

NotificationPoint.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  isConfirmed: PropTypes.bool,
  isEnabled: PropTypes.bool,
  isEditing: PropTypes.bool,
  isSaving: PropTypes.bool,
  isToggling: PropTypes.bool,
  isChecking: PropTypes.bool,
  isCodeSending: PropTypes.bool,
  isCodeInvalid: PropTypes.bool,
  togglePoint: PropTypes.func,
  toggleEditingState: PropTypes.func,
  saveNotificationPoint: PropTypes.func,
  confirmNotificationPointCode: PropTypes.func,
  resetPointCodeValidation: PropTypes.func,
  resendCode: PropTypes.func,
  toggleConfirmationCodePopup: PropTypes.func,
  isRecoveryPassword: PropTypes.bool,
  isConfirmationOpened: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
};

export default NotificationPoint;
